import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as relationship from '../relationship'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: relationship.RESOURCE.payload.dimension.partialId,
      partialId: relationship.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Denotes the kind of leader this is (e.g. manager, mentor, etc.)',
    isOptional: false,
    name: 'Leader Type',
    partialId: PartialId.Standard.create('leader_type'),
    type: {
      enumId: core.dms.models.Enum.Id.from(enums.leaderType.RESOURCE.payload),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
